<template>
    <footer>
        <div class="scale">
            <p class="small">画像はイメージです。実際の製品とは異なる<br class="sp">
                場合があります。<br class="pc">製品仕様・サイズについては、<br class="sp">
                カタログ等でご確認ください。</p>
            <ScaleController :disabled="disableZoom" />
            <div>
                <PaintModeButton/>
                <DownloadButton class="download"/>
            </div>
        </div>
    </footer>

</template>

<script>
    import ScaleController from '../parts/ScaleController'
    import DownloadButton from '../parts/DownloadButton'
    import PaintModeButton from '../parts/PaintModeButton'
    import CONST from '../../assets/js/const'
    import { mapState } from "vuex";

    export default {
        name: "TempFooter",
        components: { ScaleController, DownloadButton, PaintModeButton },
        computed: {
            ...mapState(['edit_mode']),
            disableZoom () {
                return this.edit_mode === CONST.EDIT_MODE_CLIPPING;
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../../assets/css/define";

    footer{
        margin: 20px calc(21 / 667 * 100%) ;
        .scale{
            width: 100%;
            margin: 0 auto;
            display: flex;
            align-items: center;
            justify-content: space-between;
            position: relative;
            p{
                font-size: clamp(10px, 1vw, 12px);
                margin: 0 10px 0 0;
            }
            div{
                display: flex;
            }
        }
    }
    @media (max-width: 739px) {
        footer{
            margin: 10px calc(21 / 667 * 100%) 5px;
        }
    }

</style>
